import React from 'react';
import Modal from '../../modal/Modal';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'react-bootstrap';
import ImageLoader from '../../images/ImageLoader';

var PegsAwardedModal = function PegsAwardedModal(props) {
  var _model$Headline, _model$Headline2, _model$ButtonLink, _model$ButtonLink$val, _model$ButtonLabel;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide,
      pegs = props.pegs;
  var headline = (model === null || model === void 0 ? void 0 : (_model$Headline = model.Headline) === null || _model$Headline === void 0 ? void 0 : _model$Headline.value) ? model === null || model === void 0 ? void 0 : (_model$Headline2 = model.Headline) === null || _model$Headline2 === void 0 ? void 0 : _model$Headline2.value.replace('$pegs', pegs) : '';

  var handleButtonClick = function handleButtonClick(href) {
    return function () {
      hide();

      if (href && href !== '') {
        window.location.href = href;
      }
    };
  };

  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--receipt-scan-modal',
    show: show,
    hide: hide,
    hideCloseButton: true,
    backdrop: true,
    noHeader: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan-modal__body-container cb-receipt-scan-modal__body-container--pegs-awarded'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'div',
    className: 'cb-receipt-scan-modal__body-container__title',
    field: model === null || model === void 0 ? void 0 : model.ModalTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan-modal__peg-counter'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: model === null || model === void 0 ? void 0 : model.Image,
    className: "cb-receipt-scan-modal__peg-counter__bg-image"
  }), /*#__PURE__*/React.createElement("span", {
    className: 'cb-receipt-scan-modal__peg-counter__pegs'
  }, "+", pegs)), /*#__PURE__*/React.createElement(Text, {
    tag: 'div',
    className: 'cb-receipt-scan-modal__body-container__header cb-receipt-scan-modal__body-container__header--pegs-awarded',
    field: {
      value: headline
    }
  }), /*#__PURE__*/React.createElement(RichText, {
    field: model === null || model === void 0 ? void 0 : model.Copy,
    tag: "span",
    className: 'cb-receipt-scan-modal__body-container__copy cb-receipt-scan-modal__body-container__copy--pegs-awarded'
  }), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-receipt-scan-modal__body-container__button",
    onClick: handleButtonClick((model === null || model === void 0 ? void 0 : (_model$ButtonLink = model.ButtonLink) === null || _model$ButtonLink === void 0 ? void 0 : (_model$ButtonLink$val = _model$ButtonLink.value) === null || _model$ButtonLink$val === void 0 ? void 0 : _model$ButtonLink$val.href) || '')
  }, (model === null || model === void 0 ? void 0 : (_model$ButtonLabel = model.ButtonLabel) === null || _model$ButtonLabel === void 0 ? void 0 : _model$ButtonLabel.value) || ''))));
};

export default PegsAwardedModal;